import VirtualDomElement from '../VirtualDomElement';

export default class RectangleElement extends VirtualDomElement {
  constructor(x, y, width, height) {
    super();
    this.set('x', x);
    this.set('y', y);
    this.set('width', width);
    this.set('height', height);
  }
}
